const {
  SERVICEINVOICE,
  PRODUCTINVOICE,
  CONSUMERINVOICE
} = require('constants/types');

const getEndpointByInvoiceModel = (model) => {
  switch (model) {
    case SERVICEINVOICE:
      return 'service-invoices';
    case PRODUCTINVOICE:
      return 'product-invoices';
    case CONSUMERINVOICE:
      return 'consumer-invoices';
    default:
      return null;
  }
};

export default getEndpointByInvoiceModel;
